export default {
  feedback: {
    success: 'Mobiilisovellus tallennettu onnistuneesti',
    error: 'Mobiilisovelluksen tallennus epäonnistui',
  },
};
